// StarRating.jsx
import React from "react";
import ReactStars from "react-rating-stars-component";
import PropTypes from "prop-types";

const StarRating = ({ rating, onRatingChange, disabled = false }) => {
  return (
    <ReactStars
      count={5}
      onChange={onRatingChange}
      size={30}
      isHalf={true}
      activeColor="#ffd700"
      value={rating}
      edit={!disabled} // 🔥 Estää tähdistön muokkaamisen jos disabled
    />
  );
};

StarRating.propTypes = {
  rating: PropTypes.number,
  onRatingChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool // 🔥 Tämä tarvitaan myös
};

export default StarRating;
